import type { ReactNode } from 'react';
import { createContext, use } from 'react';

import { invariant } from '#/utils/invariant';

import type { AppConfig } from './types/AppConfig';

const AppConfigContext = createContext<AppConfig | null>(null);

export function AppConfigContextProvider({
  appConfig,
  children,
}: {
  appConfig: AppConfig;
  children: ReactNode;
}) {
  return <AppConfigContext value={appConfig}>{children}</AppConfigContext>;
}

export function useAppConfig() {
  const appConfig = use(AppConfigContext);
  invariant(appConfig !== null, 'App config not available');

  return { appConfig };
}
